import React, { useState, useEffect } from 'react';
import ApiService from '../../services/apiService';
import { setRows } from '../../../Redux/actions/rowActions';
import { useCurrency } from '../../Layouts/currencyContext';
import { useDispatch, useSelector } from 'react-redux';
import { PO_ITEM_COL } from './poItemGridColumns';
import Tooltip from '../purchaseRequisition/tooltip';
const ItemGridView = ({ itemData, currencyPrecision,
  setOverallDiscount, grandTotal, setVatAmount, vatAmount,
  overallDiscount, setDiscountAmount, discountAmount, setGrandTotal
}) => {

  const apiService = new ApiService();
  const dispatch = useDispatch();
  const [overallDiscountAmount, setOverallDiscountAmount] = useState(); // Amount

  const rows = useSelector((state) => state.rows.rows);

  const calculatedTotal = rows.reduce((sum, row) => {
    const amount = parseFloat(row?.amount) || 0;
    const vatAmount = parseFloat(row?.vatAmount) || 0;
    const discount = parseFloat(row?.discount) || 0;
    let final = overallDiscount === 0 ? ((amount + discount) - vatAmount) : (amount - vatAmount)

    return sum + (final);
  }, 0);
  const totalItemDiscount = rows.reduce((sum, row) => { return sum + Number(row?.discount || 0); }, 0);

  useEffect(() => {
    const getItems = async () => {
      const formattedRowsPromises = itemData?.poDetails
        ?.map(async (detail, index) => {
          const getunit = await apiService.getApiParamater('GET_ITEM_PACK', `?ItemNo=${detail.itemCode}`);
          // const selectedItem = res.data.result?.find(item => item.itemNo === detail.itemCode);

          let selectedItem = getunit?.data?.result[0];
          let calculatedAmount = (parseFloat(detail?.unitPrice) * parseFloat(detail?.qty))
          return {
            srno: detail?.srno,
            itemCode: detail.itemCode,
            recordId: detail.itemCode,
            itemDescription: detail.itemDescription,
            qty: detail.qty || 0,
            unitPrice: detail.unitPrice,
            calculatedAmount: calculatedAmount?.toFixed(currencyPrecision || 3),
            vat: detail?.vatPerc || 0,
            uom: detail.uom,
            stock: detail.qty * selectedItem.convToInvUOM,
            baseQty: selectedItem.convToInvUOM,
            specification: detail.specification,
            discount: detail.discount,
            discountAmount: detail?.discountamount,
            amount: detail?.amount,
            vatAmount: detail?.vatAmount?.toFixed(currencyPrecision || 3) || 0,
          };
        })
        .filter((row) => row !== null);
      const formattedRows = await Promise.all(formattedRowsPromises);
      if (formattedRows?.length > 0) {
        setRows(formattedRows.reverse());
        dispatch(setRows(formattedRows));
      }
    };
    if (itemData) {
      getItems();
    }
  }, [itemData]);

  useEffect(() => {

    const grossAmount = rows.reduce(
      (sum, row) => sum + Number(row?.amount || 0),
      0
    );
    let discountAmt = (calculatedTotal * Number(overallDiscount || 0)) / 100;

    const afterDiscount =
      calculatedTotal -
      (discountAmt === 0 ? totalItemDiscount : discountAmt);

    // const vatAmount = (afterDiscount * vat) / 100;

    let vatAmount = 0;

    if (rows.length === 1) {

      const vatRate = rows[0]?.vat;
      vatAmount = (afterDiscount * vatRate) / 100;
    } else {
      // Get unique VAT rates
      const uniqueVatRates = [
        ...new Set(rows.map((r) => Number(r?.vat || 0))),
      ];

      if (uniqueVatRates.length === 1) {
        // Same VAT on all rows
        const vatRate = uniqueVatRates[0];
        vatAmount = (afterDiscount * vatRate) / 100;
      } else {
        // Different VAT rates
        vatAmount = rows.reduce(
          (sum, row) => sum + Number(row?.vatAmount || 0),
          0
        );
      }
    }

    const grandTotal = afterDiscount + vatAmount;

    setDiscountAmount(Number(discountAmt.toFixed(3)));
    setVatAmount(Number(vatAmount.toFixed(3)));
    setGrandTotal(Number(grandTotal.toFixed(3)));
    // Only update the opposite field
    setOverallDiscountAmount(Number(discountAmt.toFixed(3)));

  }, [
    rows,
    overallDiscount,
    overallDiscountAmount,
  ]);

  const [columnWidths, setColumnWidths] = useState({
    remove: 40,
    srNo: 80,
    itemNo: 150,
    description: 300,
    specification: 150,
    qty: 100,
    unitPrice: 120,
    discount: 120,
    calculatedAmount: 180,
    vat: 100,
    vatAmount: 160,
    amount: 140,
    inventoryQty: 140,
    lastPurchasePrice: 180
  });
  const ResizableHeader = ({ column, children }) => {
    return (
      <th
        style={{
          width: `${columnWidths[column]}px`,
          minWidth: `${columnWidths[column]}px`,
          position: 'relative'
        }}
      >
        {children}

        <span
          className="resize-handle"
          onMouseDown={(e) => startResize(e, column)}
        />
      </th>
    );
  };
  const startResize = (e, column) => {
    e.preventDefault();

    const startX = e.clientX;
    const startWidth = columnWidths[column];

    const handleMouseMove = (event) => {
      const newWidth = Math.max(
        50,
        startWidth + (event.clientX - startX)
      );

      setColumnWidths(prev => ({
        ...prev,
        [column]: newWidth
      }));
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };
  return (
    <div>
      <div className="row mb-3">
        <div className="col-md-4">
          <label>Discount %</label>
          <input
            type="number"
            className="form-control"
            value={overallDiscount}
            disabled
          />
        </div>
        <div className="col-md-4">
          <label>Discount Amount</label>
          <input
            type="number"
            className="form-control"
            value={overallDiscountAmount}
            disabled
          />
        </div>
      </div>
      <div className="table-container p-2 mb-5" style={{ overflowX: 'auto', height: '400px' }}>
        <table>
          <thead className="dynoTable">
            <tr>
              <ResizableHeader column="srNo">
                Sr no
              </ResizableHeader>

              <ResizableHeader column="itemNo">
                Item No
              </ResizableHeader>

              <ResizableHeader column="description">
                Description
              </ResizableHeader>

              <ResizableHeader column="specification">
                Item Specs
              </ResizableHeader>

              <ResizableHeader column="qty">
                Qty
              </ResizableHeader>

              <ResizableHeader column="unitPrice">
                Unit Price
              </ResizableHeader>

              <ResizableHeader column="discount">
                Discount
              </ResizableHeader>

              <ResizableHeader column="calculatedAmount">
                Calculated Amount
              </ResizableHeader>

              <ResizableHeader column="vat">
                VAT %
              </ResizableHeader>

              <ResizableHeader column="vatAmount">
                VAT Amount
              </ResizableHeader>

              <ResizableHeader column="amount">
                Amount
              </ResizableHeader>

              <ResizableHeader column="inventoryQty">
                Inventory Qty
              </ResizableHeader>

              <ResizableHeader column="lastPurchasePrice">
                Last Purchase Price
              </ResizableHeader>
            </tr>
          </thead>
        </table>
        <tbody>
          {rows?.map((row, index) => (
            <tr key={index}>

              {/* Sr No */}
              <td
                className="m-0 p-0"
                style={{
                  width: `${columnWidths.srNo}px`,
                  minWidth: `${columnWidths.srNo}px`
                }}
              >
                <input
                  className="p-2"
                  type="text"
                  value={index + 1}
                  disabled
                  style={{
                    width: "100%",
                    boxSizing: "border-box"
                  }}
                />
              </td>

              {/* Item No */}
              <td
                className="m-0 p-0"
                style={{
                  width: `${columnWidths.itemNo}px`,
                  minWidth: `${columnWidths.itemNo}px`
                }}
              >
                {/* <Tooltip text={row.itemCode}> */}
                <input
                  className="p-2"
                  disabled
                  value={row.itemCode}
                  style={{
                    width: "100%",
                    boxSizing: "border-box"
                  }}
                />
                {/* </Tooltip> */}
              </td>

              {/* Description */}
              <td
                className="m-0 p-0"
                style={{
                  width: `${columnWidths.description}px`,
                  minWidth: `${columnWidths.description}px`
                }}
              >
                {/* <Tooltip text={row.itemDescription}> */}
                <input
                  className="p-2"
                  disabled
                  value={row.itemDescription}
                  style={{
                    width: "100%",
                    boxSizing: "border-box"
                  }}
                />
                {/* </Tooltip> */}
              </td>

              {/* Specification */}
              <td
                className="m-0 p-0"
                style={{
                  width: `${columnWidths.specification}px`,
                  minWidth: `${columnWidths.specification}px`
                }}
              >
                {/* <Tooltip text={row.specification}> */}
                <input
                  className="p-2"
                  type="text"
                  disabled
                  value={row.specification}
                  style={{
                    width: "100%",
                    boxSizing: "border-box"
                  }}
                />
                {/* </Tooltip> */}
              </td>

              {/* Qty */}
              <td
                className="m-0 p-0"
                style={{
                  width: `${columnWidths.qty}px`,
                  minWidth: `${columnWidths.qty}px`
                }}
              >
                <input
                  className="p-2"
                  disabled
                  value={row.qty}
                  style={{
                    width: "100%",
                    boxSizing: "border-box"
                  }}
                />
              </td>

              {/* Unit Price */}
              <td
                className="m-0 p-0"
                style={{
                  width: `${columnWidths.unitPrice}px`,
                  minWidth: `${columnWidths.unitPrice}px`
                }}
              >
                <input
                  className="p-2"
                  disabled
                  value={row.unitPrice}
                  style={{
                    width: "100%",
                    boxSizing: "border-box"
                  }}
                />
              </td>

              {/* Discount */}
              <td
                className="m-0 p-0"
                style={{
                  width: `${columnWidths.discount}px`,
                  minWidth: `${columnWidths.discount}px`
                }}
              >
                <input
                  className="p-2"
                  disabled
                  value={row.discount}
                  style={{
                    width: "100%",
                    boxSizing: "border-box"
                  }}
                />
              </td>

              {/* Calculated Amount */}
              <td
                className="m-0 p-0"
                style={{
                  width: `${columnWidths.calculatedAmount}px`,
                  minWidth: `${columnWidths.calculatedAmount}px`
                }}
              >
                <input
                  className="p-2"
                  disabled
                  value={row.calculatedAmount}
                  style={{
                    width: "100%",
                    boxSizing: "border-box"
                  }}
                />
              </td>

              {/* VAT % */}
              <td
                className="m-0 p-0"
                style={{
                  width: `${columnWidths.vat}px`,
                  minWidth: `${columnWidths.vat}px`
                }}
              >
                <input
                  className="p-2"
                  type="text"
                  value={
                    row?.vat === undefined
                      ? "0"
                      : `${row.vat}%`
                  }
                  disabled
                  style={{
                    width: "100%",
                    boxSizing: "border-box"
                  }}
                />
              </td>

              {/* VAT Amount */}
              <td
                className="m-0 p-0"
                style={{
                  width: `${columnWidths.vatAmount}px`,
                  minWidth: `${columnWidths.vatAmount}px`
                }}
              >
                <input
                  className="p-2"
                  type="text"
                  value={row?.vatAmount || 0}
                  disabled
                  style={{
                    width: "100%",
                    boxSizing: "border-box"
                  }}
                />
              </td>

              {/* Amount */}
              <td
                className="m-0 p-0"
                style={{
                  width: `${columnWidths.amount}px`,
                  minWidth: `${columnWidths.amount}px`
                }}
              >
                <input
                  className="p-2"
                  disabled
                  value={Number(
                    row?.amount || 0
                  ).toFixed(currencyPrecision || 3)}
                  style={{
                    width: "100%",
                    boxSizing: "border-box"
                  }}
                />
              </td>

              {/* Inventory Qty */}
              <td
                className="m-0 p-0"
                style={{
                  width: `${columnWidths.inventoryQty}px`,
                  minWidth: `${columnWidths.inventoryQty}px`
                }}
              >
                <input
                  className="p-2"
                  disabled
                  value={row?.stock || 0}
                  style={{
                    width: "100%",
                    boxSizing: "border-box"
                  }}
                />
              </td>

            </tr>
          ))}
        </tbody>
      </div>

      <div className="d-flex justify-content-between boxs">
        <div className="d-flex gap-2">
          <div className="totalhead center">Total Amount</div>
          <div className="field">{parseFloat(calculatedTotal)?.toFixed(currencyPrecision || 3) || '---'}</div>
        </div>
        <div>
          <div className="totalhead center">_</div>
        </div>
        <div className="d-flex gap-2">
          <div className="totalhead center">Total Discount</div>
          <div className="field">{Number(discountAmount).toFixed(currencyPrecision || 3)}</div>
        </div>
        <div>
          <div className="totalhead center">=</div>
        </div>
        <div className="d-flex gap-2">
          <div className="totalhead center">After Discount</div>
          <div className="field">{(calculatedTotal - discountAmount).toFixed(currencyPrecision || 3)}</div>
        </div>
        <div>
          <div className="totalhead center">+</div>
        </div>
        <div className="d-flex gap-2">
          <div className="totalhead center">Total Vat</div>
          <div className="field">{parseFloat(vatAmount)?.toFixed(currencyPrecision || 3) || '---'}</div>
        </div>
        <div>
          <div className="totalhead center">=</div>
        </div>
        <div className="d-flex gap-2">
          <div className="totalhead center">Net Amount</div>
          <div className="field">{parseFloat(grandTotal)?.toFixed(currencyPrecision || 3) || '---'}</div>
        </div>
      </div>
    </div>
  );
};

export default ItemGridView;
